export default "/images/1548408796feb94a8e29c9436ebd02c9.avif";